export default "__VITE_ASSET__DT5GvmR6__"